import React, { useState, useEffect, useRef } from "react";
import { Card } from "antd";
import { pathOr } from "ramda";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import CustomButton from "../../components/customButton";
import Layout from "../../components/layout";
import CommonTable from "../../components/commonTable";
import { MOBILE_WIDTH, patientReportsColumns } from "../../constants/constants";
import CommonService from "../../service/CommonService";
import CustomNotification from "../../components/notification";
import { setPopup } from "../../actions/popupAction";
import { downloadPatientFilesSagaAction } from "../../sagas/saga-fileDownload";
import loginService from "../../service/login";
import { selectedFile } from "../../assets/svg";
import useWindowDimensions from "../../components/custom-hooks/useWindowDimensions";
import MobileHeader from "../../components/header/mobileHeader";
import "./styles.scss";

const PatientReport = (props) => {
  const commonService = new CommonService();

  const history = useHistory();

  const downloadRef = useRef([]);

  const [state, setState] = useState({
    downloading: {},
    updateTable: false,
    liveChatAccess: false,
    backPath: "/",
  });

  const fetchReports = async (filters) => {
    const data = await commonService.getReportsList(
      filters.page,
      15,
      filters.order,
      filters.search ? encodeURIComponent(JSON.stringify(filters.search)) : ""
    );
    const formattedData = data.data.map((obj, index) => {
      return {
        key: index,
        patientId: obj.patientId,
        patientCellPhoneNo: obj.patientCellPhoneNo,
        timeElapsed: obj.timeElapsed,
        fileStatus: obj.fileStatus,
      };
    });
    return { rows: formattedData, count: data.count };
  };

  const getSuggestions = async (column, value) => {
    const data = await commonService.getReportsListSuggestions(column, value);
    return data;
  };

  const downloadFiles = (patientid, filename, row) => {
    const object = {
      patientId: patientid,
      filename: filename,
    };
    if (((downloadRef && downloadRef.current) || []).includes(filename)) return;
    if (downloadRef && downloadRef.current) {
      downloadRef.current.push(filename);
    } else {
      downloadRef.current = [filename];
    }
    setState((st) => ({
      ...st,
      downloading: { ...st.downloading, [filename]: true },
    }));

    const setDownloaded = () => {
      setState((st) => ({
        ...st,
        downloading: { ...st.downloading, [filename]: false },
      }));
    };

    props.downloadPatientFiles(object, (result) => {
      if (result && result.status === 200) setDownloaded();
      else {
        props.setPopup({
          customPopupMessage: true,
          message: pathOr(
            "No file(s) available to download.",
            ["response", "data", "message"],
            result.error
          ),
          messageType: "error",
        });
        setState((st) => ({
          ...st,
          downloading: { ...st.downloading, [filename]: false },
        }));
      }
      downloadRef.current =
        downloadRef &&
        downloadRef.current &&
        downloadRef.current.filter((i) => i !== filename);
    });
  };

  const hidePatientReport = () => {
    history.push("/chat");
  };

  const updatePatientReportStatus = () => {
    setState((st) => ({ ...st, updateTable: !st.updateTable }));
  };

  useEffect(() => {
    const decodedToken = loginService.getDecodedToken();
    const user = decodedToken && decodedToken.payload;
    const { liveChatAccess, liveAgentAccess, reportOnlyAccess } = user || {};

    setState((prevState) => ({ ...prevState, liveChatAccess }));

    if (!reportOnlyAccess) {
      if (!liveChatAccess && !liveAgentAccess) {
        history.push("/broadcast");
      }
      if (!liveChatAccess) {
        history.push("/chat-agent");
      }
    }
    // socket event listener for socket service
    window.addEventListener(
      "updatePatientReportStatus",
      (e) => {
        updatePatientReportStatus(e.detail);
      },
      false
    );

    return () => {
      window.removeEventListener(
        "updatePatientReportStatus",
        updatePatientReportStatus
      );
    };
  }, []);

  const { customPopupMessage, messageType, message } = props.popupReducer;

  const decodedToken = loginService.getDecodedToken();
  const loggedinUser = decodedToken?.payload;

  useEffect(() => {
    if (loggedinUser?.liveChatAccess && loggedinUser?.reportOnlyAccess) {
      setState((st) => ({
        ...st,
        backPath: "/",
      }));
    } else if (
      loggedinUser?.broadcastAccess &&
      loggedinUser?.reportOnlyAccess
    ) {
      setState((st) => ({
        ...st,
        backPath: "/broadcast",
      }));
    }
  }, []);

  const { width } = useWindowDimensions();

  const checkForAccess = () => {
    if (loggedinUser?.liveChatAccess && loggedinUser?.reportOnlyAccess) {
      return true;
    } else if (
      loggedinUser?.broadcastAccess &&
      loggedinUser?.reportOnlyAccess
    ) {
      return true;
    } else if (loggedinUser?.reportOnlyAccess) {
      return false;
    }
    return true;
  };

  const showAccountDetails = () => {
    if (loggedinUser?.liveChatAccess && loggedinUser?.reportOnlyAccess) {
      return false;
    } else if (
      loggedinUser?.broadcastAccess &&
      loggedinUser?.reportOnlyAccess
    ) {
      return false;
    } else if (loggedinUser?.reportOnlyAccess) {
      return true;
    }
    return false;
  };

  const showBroadcastButton = () => {
    if (
      loggedinUser?.liveChatAccess &&
      loggedinUser?.broadcastAccess &&
      loggedinUser?.reportOnlyAccess
    ) {
      return false;
    } else if (loggedinUser?.reportOnlyAccess) {
      return true;
    }
    return false;
  };

  return (
    <Layout testId="patient-report-page-wrapper">
      <div className="display-in-mob">
        <MobileHeader
          showLogo={false}
          showBackButton={checkForAccess()}
          showPageTitle={true}
          pageTitle="Patient Reports"
          showNotifications={false}
          showHelp={false}
          showAccountDetails={showAccountDetails()}
          handleBackButton={() => {
            history.push(state.backPath);
          }}
        />
      </div>
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      <div className="inner-content-wrapper">
        {showBroadcastButton() &&
          width < MOBILE_WIDTH && (
            <div className="broadcast-report-nav">
              <span
                onClick={() => {
                  history.push("/broadcast/report");
                }}
              >
                Go to Broadcast Report
              </span>
            </div>
          )}
        <Card
          className="primary-card live-chat-card patient-report-card"
          title="Live Chat"
          extra={
            <div className="close-container">
              {!!state.liveChatAccess && (
                <CustomButton
                  btntype="clear"
                  title="Close"
                  onClick={hidePatientReport}
                  className="mr-8"
                />
              )}
              <div className="selected-report">{selectedFile}</div>
            </div>
          }
        >
          <CommonTable
            title="Patient Files"
            columns={patientReportsColumns(downloadFiles, state.downloading)}
            fetchData={fetchReports}
            getSuggestions={getSuggestions}
            forceUpdate={state.forceUpdate}
            updateTable={state.updateTable}
          />
        </Card>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  popupReducer: state.popupReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setPopup: (data) => dispatch(setPopup(data)),
    downloadPatientFiles: (object, cb) => {
      dispatch(downloadPatientFilesSagaAction(object, cb));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientReport);
